import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import {
  DataProvider,
  ParameterProvider,
  ServiceProvider,
  useTheme,
} from "contexts";
import { Common } from "components";

export const EmptyLayout = () => {
  const { theme } = useTheme();

  return (
    <ParameterProvider>
      <ServiceProvider>
        <DataProvider>
          <Box component="main" bgcolor={theme.color.background.color}>
            <Box sx={{ display: "grid", flexGrow: 1 }}>
              <Outlet />
            </Box>
          </Box>
          <Common.Message />
        </DataProvider>
      </ServiceProvider>
    </ParameterProvider>
  );
};
